// -- AJAX --------------------------------------------------------------------
export const AJAX_CALL_STARTED = 'AJAX_CALL_STARTED';
export const AJAX_CALL_ENDED = 'AJAX_CALL_ENDED';
export const AJAX_CALL_FAILED = 'AJAX_CALL_FAILED';

// -- REFERENCES --------------------------------------------------------------
export const USER_SESSION_MODEL_RECIEVED = 'USER_SESSION_MODEL_RECIEVED';
export const LOGIN_MODEL_RECIEVED = 'LOGIN_MODEL_RECIEVED';


// -- REFERENCES --------------------------------------------------------------
export const REFERENCES_LOADED = 'REFERENCES_LOADED';

// -- SPORTCLUBS --------------------------------------------------------------
export const SPORTCLUBS_LOADED = 'SPORTCLUBS_LOADED';

// -- INFRASTRUCTUREN ---------------------------------------------------------
export const INFRASTRUCTUREN_BY_SPORTCLUB_LOADED = 'INFRASTRUCTUREN_BY_SPORTCLUB_LOADED';

export const UPDATE_NIEUWESPORTCLUB_MODEL = 'UPDATE_NIEUWESPORTCLUB_MODEL';

export const ACTIVE_TOPNAVITEMID_UPDATED = 'ACTIVE_TOPNAVITEMID_UPDATED';
export const LAYOUT_UPDATED = 'LAYOUT_UPDATED';
export const SET_SCOPE = 'SET_SCOPE';

export const ADD_ERROR = 'ADD_ERROR';
export const CLEAR_ERRORS = 'CLEAR_ERRORS';

export const SET_UNSAVED_CHANGES = 'SET_UNSAVED_CHANGES';

export const THROW_EXCEPTION = 'THROW_EXCEPTION';
export const CLEAR_EXCEPTION = 'CLEAR_EXCEPTION';

export const READ_SETTINGS_SUCCESS = 'READ_SETTINGS_SUCCESS';
export const ACCOUNT_SET = 'ACCOUNT_SET';
export const DISABLE_PAGE = 'DISABLE_PAGE';

export const VALIDATIESTATUS_LOADED = 'VALIDATIESTATUS_LOADED';

export const ACTIVE_ONDERNEMING_SET = 'ACTIVE_ONDERNEMING_SET';
export const ACTIVE_USER_SET = 'ACTIVE_USER_SET';
export const ACTIVE_SPORTCLUBID_SET = 'ACTIVE_SPORTCLUBID_SET';
export const ACTIVE_ORGANISATIENIVEAU_SET = 'ACTIVE_ORGANISATIENIVEAU_SET';
export const ACTIVE_TRANSACTIONID_SET = 'ACTIVE_TRANSACTIONID_SET';
export const SPORTCLUBSEARCHMODEL_SET = 'SPORTCLUBSEARCHMODEL_SET';
export const USERTYPE_SET = 'USERTYPE_SET';
export const AUTHORIZATION_INFO_LOADED = 'AUTHORIZATION_INFO_LOADED';
export const SET_CURRENT_ORGANISATION = 'SET_CURRENT_ORGANISATION';

export const ACTIVATE_SPORTORGANISATIE_POPUP_SHOWN = 'ACTIVATE_SPORTORGANISATIE_POPUP_SHOWN';
export const RESET_ACTIVATE_SPORTORGANISATIE_POPUP_SHOWN = 'RESET_ACTIVATE_SPORTORGANISATIE_POPUP_SHOWN';

// -- MODAL --------------------------------------------------------------
export const CUSTOM_MODAL_SET = 'CUSTOM_MODAL_SET';
export const CUSTOM_MODAL_RESET = 'CUSTOM_MODAL_RESET';
